import { render, staticRenderFns } from "./PwdChange.vue?vue&type=template&id=7eda62d6&scoped=true"
import script from "./PwdChange.vue?vue&type=script&lang=js"
export * from "./PwdChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda62d6",
  null
  
)

export default component.exports